import { shuffle } from 'lodash';
import { Keyboard } from 'react-native';
import React, { useCallback, useMemo } from 'react';
import { Spacer } from 'design-system/Spacer';
import SectionHeader from 'design-system/SectionHeader';
import useIsTablet from 'hooks/useIsTablet';
import { isWeb } from '../../constants';
import SuggestionsList from './SuggestionsList';
import SuggestionsListWrap from './SuggestionsListWrap';
function findClosestPairToDiff(shorter, longer, diff, depth) {
    let smallestDiff = diff;
    let pairToSwap;
    for (let i = 0; i < shorter.length; i++) {
        for (let j = 0; j < longer.length; j++) {
            const newDiff = diff - longer[j].name.length + shorter[i].name.length;
            if (newDiff < smallestDiff) {
                smallestDiff = newDiff;
                pairToSwap = [i, j];
            }
        }
    }
    if (smallestDiff > 7 && depth < 4) {
        return findClosestPairToDiff(shorter, longer, smallestDiff, depth + 1);
    }
    return pairToSwap;
}
const Suggestions = ({ title, data, name, suggestedData, handleSuggestionPress, }) => {
    const isTablet = useIsTablet();
    const suggestions = useMemo(() => {
        const shuffledData = shuffle(data);
        const midIndex = Math.floor((shuffledData.length + 1) / 2);
        const [top, bottom] = [
            shuffledData.slice(0, midIndex),
            shuffledData.slice(midIndex, shuffledData.length),
        ];
        const topLetters = top.reduce((acc, item) => acc + item.name.length, 0);
        const bottomLetters = bottom.reduce((acc, item) => acc + item.name.length, 0);
        const diff = Math.abs(topLetters - bottomLetters);
        if (diff < 8) {
            return [top, bottom];
        }
        const [shorter, longer] = topLetters < bottomLetters ? [top, bottom] : [bottom, top];
        const pairToSwap = findClosestPairToDiff(shorter, longer, diff, 0);
        if (pairToSwap) {
            const [shorterIndex, longerIndex] = pairToSwap;
            [shorter[shorterIndex], longer[longerIndex]] = [
                longer[longerIndex],
                shorter[shorterIndex],
            ];
        }
        return [shorter, longer];
    }, [data]);
    const didUserAlterName = name !== suggestedData?.name;
    const handlePress = useCallback((name, emoji) => {
        Keyboard.dismiss();
        handleSuggestionPress(name, emoji);
    }, [handleSuggestionPress]);
    return (<>
      <Spacer h={8}/>
      <SectionHeader horizontalMargins verticalMargins>
        {title}
      </SectionHeader>
      <Spacer h={4}/>
      {isTablet || isWeb ? (<SuggestionsListWrap suggestions={suggestions} handleSuggestionPress={handlePress} didUserAlterName={didUserAlterName} suggestedName={suggestedData?.name}/>) : (<SuggestionsList suggestions={suggestions} handleSuggestionPress={handlePress} didUserAlterName={didUserAlterName} suggestedName={suggestedData?.name} oneLine={data.length < 6}/>)}
    </>);
};
export default React.memo(Suggestions);
